module.exports = __webpack_public_path__ + "img/melhor-envio.e32ed327.png";